import { createAction, createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';
import { type SagaConfig } from '@sagas/request/types';

import type { PermissionsRequest, PermissionsState, PermissionsUpdateRequest } from './types';

export const initialState: PermissionsState = {
  model: {},
  meta: {
    errorMessage: '',
    status: STATUS.LOADING,
  },
};

export const permissionsRequest = createAction<PermissionsRequest>('permissions/request');
export const permissionsUpdateRequest = createAction<PermissionsUpdateRequest>(
  'permissions/updateRequest'
);
export const accessEntitiesRequest = createAction<{ sagaConfig?: SagaConfig }>(
  'accessEntities/request'
);

const permissions = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    reset: () => initialState,
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload.result;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    updateSuccess: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model = action.payload.result;
    },
    updateFailure: state => {
      state.meta.status = STATUS.ERROR;
    },
  },
  extraReducers: builder => {
    builder.addCase(permissionsRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    });
    builder.addCase(permissionsUpdateRequest.type, state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.UPDATING;
    });
  },
});

export const {
  reset: permissionsReset,
  success: permissionsSuccess,
  failure: permissionsFailure,
  updateSuccess: permissionsUpdateSuccess,
  updateFailure: permissionsUpdateFailure,
} = permissions.actions;

export default permissions.reducer;
